/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit } from '@angular/core';
import { VenuesService } from '@app/settings/venues/venues.service';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { ApiQuery, GeoFenceFilter } from '@app/core/http/api-query';
import { Venue } from '@app/settings/venues/venue.model';
import { Observable } from 'rxjs';
import { City } from '@app/settings/cities/cities.model';
import { FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { VenueDistanceComponent } from '@app/shared/components/venue-distance/venue-distance.component';

@Component({
  selector: 'app-venues-in-range',
  templateUrl: './venues-in-range.component.html',
  styleUrls: ['./venues-in-range.component.scss'],
})
export class VenuesInRangeComponent implements OnInit {
  @Input() parentFormGroup: FormGroup;
  @Input() coordinates: object = { lat: null, long: null };
  @Input() city_id: number;
  data: Observable<City[]>;
  loader: boolean;

  constructor(
    private venuesService: VenuesService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {}

  ngOnInit() {}

  /**
   *
   * @param km На колко километра да търси(outer_radius)
   */
  findVenuesInRange(km: number | string) {
    if (!km) {
      this.translate.get('VENUES_IN_RANGE.RANGE_MISSING').subscribe((res: string) => {
        this.toastr.warning(res);
      });
    }
    if (!km || !this.coordinates['lat'] || !this.coordinates['long']) {
      return false;
    }
    const geoFenceFilter = new GeoFenceFilter();
    geoFenceFilter.lat = Number(this.coordinates['lat']);
    geoFenceFilter.long = Number(this.coordinates['long']);
    geoFenceFilter.inner_radius = 0;
    geoFenceFilter.outer_radius = Number(km);

    const query = new ApiQuery();
    query.setGeoFence(geoFenceFilter).setLimit(99);
    this.venuesService.index(query).subscribe((response: PaginatedResponse) => {
      this.addFromSearch(response.data);
    });
  }

  addVenuesFromCity() {
    if (!this.city_id) {
      return false;
    }
    const query = new ApiQuery();
    query.addFilter('city_id', this.city_id).setLimit(99);
    this.venuesService.index(query).subscribe((response: PaginatedResponse) => {
      this.addFromSearch(response.data);
    });
  }

  private addFromSearch(venues: Array<Venue>) {
    // @ts-ignore
    const parentFormGroup = this.parentFormGroup;
    /*
      Премахва дублиращите се venues
     */
    // @ts-ignore
    this.parentFormGroup.controls.venues.controls.forEach((formVenue: Venue, index: number) => {
      /*
      Премахва празните venues от формата, ако има намерени резултати(venues за добавяне)
      По този начин ако първия ред е празен го маха
     */
      // @ts-ignore
      if (venues.length > 0 && !formVenue.controls.id.value) {
        // @ts-ignore
        parentFormGroup.controls.venues.controls.splice(index, 1);
      }

      venues.forEach((searchVenue: Venue) => {
        // @ts-ignore
        if (formVenue.value.id === searchVenue.id) {
          venues.splice(venues.indexOf(searchVenue), 1);
        }
      });
    });

    venues.forEach((formVenue: Venue) => {
      // @ts-ignore
      parentFormGroup.controls.venues.push(VenueDistanceComponent.getEmpty(formVenue.id));
    });
    if (venues.length > 0) {
      this.translate.get('VENUES_IN_RANGE.SUCCESSFULLY_ADDED_VENUES').subscribe((res: string) => {
        this.toastr.success(res + ' ' + venues.length);
      });
    } else {
      this.translate.get('VENUES_IN_RANGE.NO_VENUES_FOUND').subscribe((res: string) => {
        this.toastr.warning(res);
      });
    }
  }
}
